export const getSettings = state => state.reportCustomerWeeklyPlans.getIn(['list', 'settings'])
export const getData = state => state.reportCustomerWeeklyPlans.getIn(['list', 'data'])
export const getFetching = state => state.reportCustomerWeeklyPlans.getIn(['list', 'fetching'])
export const getError = state => state.reportCustomerWeeklyPlans.getIn(['list', 'error'])
